let imageList = {
  logo: "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd37c83dfa3ccb0d2d9836f_myhours-logo.svg",
  footerLogo:
    "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fc9236f9ab08c7bdf83fe75_Logo-300px.png",
  homePageHeading:
    "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd337b26121202b5bfb96d7_OriginalSize(1)-p-1080.png",
  capterra:
    "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/600008d9399ba39d2583a755_Capterra-4-7.png",
  G2logo:
    "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/600008d9b4eb5ca178cc55df_g2-4-7.png",
  microsoftLogo:
    "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/600008d9487a040f81a5d142_MS-Gold.png",
  typeFoxlogo:
    "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/6000079c0b6e21682628f281_typefox%201.png",
  KPMGLogo:
    "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/6000079cd7ceecebfc3f5519_kpmg_logo%201.png",
  ImpartnerLogo:
    "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/6000079dfd768757fcf2ea64_logo-Impartner-1.png",
  SemaphoreLogo:
    "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/6000079d3f7265588b6d1dbe_semaphore-logo.png",
  AuroraLogo:
    "	https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/6000079d09b818dd84138753_aurora-logo-horiz-white%201.png",
  ManpowerLogo:
    "	https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/6000079d14844ef7226bb10a_logo_heading.png",
  homePageCards: {
    coOrdinate:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd7199052d14ec5e2a6c813_HP-1.png",
    track:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd71991bd83c222217cac17_HP-2.png",
    create:
      "	https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd71991a6df42a49f7e6d5c_HP-3.png",
  },
  usecaseImages: {
    billing:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fbf86f7f19477d80b3be5ec_Billable%20settings-p-500.png",
    timeReports:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fc0abed0af890cbb40c6d33_HP-3-1-p-500.png",
    attendance:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fc4e6828a88f435b7c4ac2a_HIW-4-p-500.png",
    expenseTracking:
      "	https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fc91420b5951fed1bb2a187_Chickens(1).png",
    projectProfitability:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fc91420b5951fed1bb2a187_Chickens(1).png",
    timesheet:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd20dcf9d62a4f65fea8acd_Frame%2027(1)(1)-p-500.png",
  },

  howItWorks: {
    organize:
      "	https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd7198fa6df4249877e6d5b_HIW-1(1).png",
    setRates:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/60c3106b6d15b4476d545c47_Project%20billing.png",
    trackTime:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/61693180d0c70441fdcc29cd_Timesheet%20with%20timer-p-1080.png",
    customReports:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd71990c1a06b2e03f1be70_HIW-4(1).png",
    timeSpent:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/61692c9dbe4680c6916e960b_time-analytics.png",
    approveLogs:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/61692ce83988430ca662abb6_Approve%20timesheets-p-1080.png",
    emailReports:
      "	https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fc4e6bd377fbe34a0cc7a0f_HIW-7.png",
    createInvoice:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fc4e6d0c755c679d71eda9f_HIW-8.png",
    accessRoles:
      "	https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fc913df96a46f4b42ee4264_Roles-p-800.png",
    calculateCosts:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fc91420b5951fed1bb2a187_Chickens(1).png",
    integrations:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fc9145d6e47e935f0570ff3_Integrations-p-500.png",
    mobileApp:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd73713f912e4498947d1a3_HIW-mobile%20(1)(1)-p-1080.png",
    noSpy:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fc4fa86e0322e7deff06f6e_Group%203.png",
  },

  support: {
    recaptcha: "https://www.gstatic.com/recaptcha/api2/logo_48.png",
  },
  mobileApp: {
    playStore:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5d0a257569e40aa076f70d9f_google-play-badge-p-500.png",
    appleStore:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5d1377b94b05c83249fe1f52_Annotation%202019-06-26%20153451.png",
    mobileTime:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fdccd7a2700c492706e7816_Mobile%20tracking.png",
    organize:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fdccd7bd8b90271165a3a4b_Organize%20projects%20mobile.png",
    mobileTimeReport:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fdccd7b07ff492a48451989_Mobile%20reporting.png",
    setRates:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fdccd7c9545cf5a4bc219ac_Set%20billable%20rates%20mobile.png",
    reminders:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fdccd7afb604e59f050714b_Reminders%20mobile.png",
    trackTime:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5c7d3bac5c2293f8364d9f24_iconfinder_simpline_56_2305606.png",
    saveMoney:
      "	https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5d08e521370a898356ef2511_4229875-128.png",
    findAndFix:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5c7d3bda314d161243dc02f8_2305598-128.png",
    beMobile:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5d08e3ff370a89a444ef221e_3428084-128.png",
    tickMark:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5c79356e59510561d68ee37f_chech%20icon.png",
  },

  feature: {
    setBillable:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd71c49d29d910c2d0d4ad8_F-1-1.png",
    addTasks:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd71c7d8001c2734403c316_F-1-2.png",
    templates:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd71cd4eb2fea310e876bfc_F-1-3.png",
    projectBudget:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd7459ce77af9b332d73027_F-2-1.png",
    advancedBudget:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd745ae6b8cccd5908bf863_F-2-2.png",
    estimateBudget:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd745be2aa1aba083c7ea5a_F-2-3.png",
    timeTracking:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd745fbe1ad8f7db8da0161_F-3-1.png",
    detailedWorklog:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd746154a63099145950c5e_F-3-2.png",
    expenseWithReceipts:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd74626c1a06b1d30f269ba_F-3-3.png",
    flexibleBill:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd746477684dab15ac0fde2_F-4-1.png",
    roundTime:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd74655304e92c42f799dce_F-4-2.png",
    markLogs:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd746664f710913d1ead0dc_F-4-3.png",
    hourlyRate:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd746f3d7b9bf7bc81a242c_F-5-1.png",
    expenses:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd747046dd03f5ee0d27249_F-5-2.png",
    calculateBalance:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd74715bb814e150a445f77_F-5-3.png",
    inviteTeam:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd7472d304e92723279a27a_F-6-1.png",
    flexibleRoles:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd7473aa6df4257377f0660_F-6-2.png",
    teamActivity:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd7474556f6667aaed5fa90_F-6-3.png",
    editLogs:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd747607e0be13f2ddd121a_F-7-1.png",
    approval:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd7477291653633e682f1ff_F-7-2.png",
    trackingReminder:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd7477f4a63095bb7951281_F-7-3.png",
    customReports:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd747e8cfa976ab8af4ca5f_F-8-1.png",
    downloadReport:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd747fbbb814eed244464aa_F-8-2.png",
    analyze:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd748085a75507de8de8b35_F-8-3.png",
    sendInvoice:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd748720b94d03dae913513_F-9-1.png",
    personalize:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd74889e1ad8f1ff6da095e_F-9-2.png",
    sendEmail:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5fd7489cc620981e07b1c5ee_F-9-3.png",
    quickbook:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5e3172e3cf36f670f74e0f40_kisspng-using-quickbooks-accounting-software-invoice-5ba10498c16f17.2263586115372791287923.png",
    zapier:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5e78886de5ba0e1fc49de4a1_zapier-logo.png",
    appleStore:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5d1377b94b05c83249fe1f52_Annotation%202019-06-26%20153451.png",
    playStore:
      "https://uploads-ssl.webflow.com/5c77a918ef19681741be7bca/5d0a257569e40aa076f70d9f_google-play-badge-p-500.png",
  },
};

export { imageList };
